import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot,Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class RoleGuard implements CanActivate {

  constructor(
    private router: Router
  ) {}

  canActivate() { 
  const currentUser = JSON.parse(localStorage.getItem('currentUser'))
    if (currentUser['roles'].includes('admin') || currentUser['roles'].includes('manager') || currentUser['roles'].includes('reimbursement_manager')) {
      return true;
    }
    window.alert("You don't have access to this page");
    this.router.navigate([`/account/${currentUser.id}/accountGoals`]);
    // this.router.navigate(['']);
    return false;
  }
}



// WEBPACK FOOTER //
// /home/bharath/agira-projects/asmart/agira-intranet-ui/src/app/guards/role.guard.ts